import React from 'react';

import styled from 'styled-components';
import Container from 'partials/Container';
import SmartLink from 'partials/SmartLink';

class NotFoundError extends React.Component {

    render() {
        return (
            <Wrapper>
                <Container>
                    <h4>Kunne ikke finne ordren.</h4>
                    <SmartLink to={'/'}>Tilbake</SmartLink>
                </Container>
            </Wrapper>
        )
    }
}

const Wrapper = styled.section`
    padding-top: 140px;
`

export default NotFoundError;
